import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GuideLayout, { GuideSection } from '../../components/GuideLayout/GuideLayout';
import { P, useGuideText } from '../../components/GuideLayout/content';
import { Note, RichText } from '../../components/ui';
import { SearchIcon } from '../../components/ui/Icons';
import { AppsIcon, GaugeIcon, HeartIcon, MoonPhaseIcon, SunEventIcon, ChartIcon, DateIcon, DevicesIcon, LocationIcon, PlayIcon, TidesIcon, WeatherIcon, } from '../../components/ui/GuideIcons';
import { settingsCategories, getOptionName } from '../../data/guides/settingsOptionsData';
import { normalizeText } from '../../utils/faq/searchUtils';
import './SettingsGuidePage.css';
/** Icon je Kategorie (ids aus settingsOptionsData) */
const CATEGORY_ICONS = {
    health: HeartIcon,
    activity: GaugeIcon,
    activityDistance: LocationIcon,
    activityTime: PlayIcon,
    dateTime: DateIcon,
    battery: DevicesIcon,
    altitude: ChartIcon,
    weather: WeatherIcon,
    sun: SunEventIcon,
    moon: MoonPhaseIcon,
    tides: TidesIcon,
    charts: ChartIcon,
    other: AppsIcon,
};
const DataFieldsGuidePage = () => {
    const { str } = useGuideText();
    const { t, i18n } = useTranslation();
    const k = 'g.dataFields';
    const lang = (i18n.language || 'en').split('-')[0];
    const [filter, setFilter] = useState('');
    const optionText = (id) => t(`dfo.options.${id}`, { defaultValue: '' }) || '';
    const categories = useMemo(() => {
        const q = normalizeText(filter.trim());
        return settingsCategories
            .map((cat) => ({
            ...cat,
            options: cat.options.filter((opt) => {
                if (!q)
                    return true;
                const name = normalizeText(getOptionName(opt.id, lang));
                const desc = normalizeText(optionText(opt.id));
                return name.includes(q) || desc.includes(q);
            }),
        }))
            .filter((cat) => cat.options.length > 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, lang, t]);
    return (_jsxs(GuideLayout, { route: "/guides/data-fields", lead: _jsx(P, { k: `${k}.lead` }), children: [_jsx(Note, { variant: "warn", label: str(`${k}.availLabel`), children: _jsx(P, { k: `${k}.availNote` }) }), _jsx(Note, { label: "\u265B PRO", children: _jsx(P, { k: "g.settings.options.pro" }) }), _jsxs("div", { className: "sg-filter", children: [_jsx(SearchIcon, { size: 18 }), _jsx("input", { id: "datafield-filter", type: "search", value: filter, onChange: (e) => setFilter(e.target.value), placeholder: str(`${k}.search`), "aria-label": str(`${k}.search`), autoComplete: "off" })] }), categories.map((cat) => {
                const Icon = CATEGORY_ICONS[cat.id];
                return (_jsxs(GuideSection, { id: `cat-${cat.id}`, title: t(`dfo.cats.${cat.id}`), children: [Icon && (_jsx("span", { className: "sg-cat-icon icon-tile frame", "aria-hidden": "true", children: _jsx(Icon, { size: 28 }) })), t(`dfo.catDesc.${cat.id}`, { defaultValue: '' }) && (_jsx("p", { className: "sg-category-description", children: t(`dfo.catDesc.${cat.id}`) })), _jsx("dl", { className: "sg-rows", children: cat.options.map((opt) => (_jsxs("div", { id: `opt-${opt.id}`, children: [_jsx("dt", { children: getOptionName(opt.id, lang) }), _jsxs("dd", { children: [_jsx(RichText, { text: optionText(opt.id) }), opt.availability && opt.availability.length > 0 && (_jsx("span", { className: "sg-avail", children: opt.availability.map((a) => (_jsx("span", { className: `sg-avail-chip sg-avail-${a}`, children: str(`${k}.avail.${a}`) }, a))) }))] })] }, opt.id))) })] }, cat.id));
            })] }));
};
export default DataFieldsGuidePage;
